/* eslint-disable */
import throttle from "lodash/throttle";

jQuery(function ($) {
  const body = $("body.single-curso");

  if (body.length === 0) return;

  const main = $(".site-main");
  const indexContent = $(".IndexContent");
  const heading = main.children(".heading-wrapper").children(".Heading");
  const modalities = main
    .children(".course-content")
    .children(".course-content--modalities");
  const header = $(".Header");
  const subscribeAnchor = $(
    ".course-content .subscribe-anchor, .heading-wrapper .subscribe-anchor"
  );

  // Cache header height outside scroll handler so we never read layout geometry
  // inside an event callback (which forces reflow after style writes).
  let cachedHeaderHeight = 0;

  const updateHeaderHeightCache = () => {
    cachedHeaderHeight =
      window.outerWidth > 1024 ? 0 : header[0] ? header[0].offsetHeight : 0;
  };

  updateHeaderHeightCache();

  // Keep the cache fresh on resize via ResizeObserver (no forced reflow).
  if (window.ResizeObserver && header[0]) {
    new ResizeObserver(() => updateHeaderHeightCache()).observe(header[0]);
  } else {
    $(window).on("resize", updateHeaderHeightCache);
  }

  const fixBlock = (scrollPos) => {
    const headerHeight = cachedHeaderHeight;
    const shouldMinimize = scrollPos > 0;

    if (shouldMinimize) {
      main.children(".heading-wrapper").addClass("sticky");
      main.children(".heading-wrapper").css("top", `${headerHeight}px`);

      // Aplica a minimização com efeito fade suave
      heading.addClass("minimized");

      // Aguarda o tempo da transição CSS (400ms) para calcular altura final
      setTimeout(() => {
        indexContent.css(
          "top",
          `${headerHeight + heading.outerHeight(true)}px`
        );
        modalities
          .children(".wrapper")
          .css("top", `${headerHeight + heading.outerHeight(true) / 2}px`);
      }, 200); // Meio da animação para melhor timing
    } else {
      main.children(".heading-wrapper").removeClass("sticky");
      main.children(".heading-wrapper").removeAttr("style");
      modalities.children(".wrapper").removeAttr("style");

      // Remove minimização com efeito fade suave
      heading.removeClass("minimized");
      subscribeAnchor.addClass("no-fixed");

      // Aguarda o tempo da transição CSS (400ms) para recalcular posições
      setTimeout(() => {
        indexContent.removeAttr("style");
      }, 200); // Meio da animação para melhor timing
    }
  };

  // Track footer visibility with IntersectionObserver instead of reading
  // getBoundingClientRect() on every scroll, which forces layout recalculation.
  let isFooterVisible = false;

  const footer = document.querySelector("footer");
  if (footer) {
    const footerObserver = new IntersectionObserver((entries) => {
      isFooterVisible = entries[0].isIntersecting;
      // Update subscribe anchor state immediately when footer visibility changes
      const headerVisible = !heading.hasClass("minimized");
      if (headerVisible || isFooterVisible) {
        subscribeAnchor.addClass("no-fixed");
      } else {
        subscribeAnchor.removeClass("no-fixed");
      }
    });
    footerObserver.observe(footer);
  }

  const checkVisibility = () => {
    const headerVisible = !heading.hasClass("minimized");
    if (headerVisible || isFooterVisible) {
      subscribeAnchor.addClass("no-fixed");
    } else {
      subscribeAnchor.removeClass("no-fixed");
    }
  };

  const throttledScroll = throttle(() => {
    fixBlock(window.scrollY);
    checkVisibility();
  }, 100);

  $(document).on("scroll", throttledScroll);

  $(window).on("resize", () => {
    fixBlock(window.scrollY);
  });

  $(document).on("load", () => {
    fixBlock(window.scrollY);
    checkVisibility();
  });

  subscribeAnchor.on("click", (e) => {
    e.preventDefault();
    const target = $(".course-content .modalities-list");
    if (target.length > 0) {
      $("html, body").animate(
        {
          scrollTop: target.offset().top - 200,
        },
        600
      );
    }
  });
});
